import React from 'react';
import { handleHiddenFields } from '../services/HiddenFieldService';
import { extractLoginPromptStep } from '../services/LoginStepService';
export class Page {
	private readonly _pageModel: PageModel;
	private readonly _loginPromptStep: StepBlock | undefined;

	public constructor(pageModel: PageModel) {
		handleHiddenFields(pageModel);
		this._loginPromptStep = extractLoginPromptStep(pageModel);
		this._pageModel = pageModel;
	}

	public get pageModel(): PageModel {
		return this._pageModel;
	}

	/** CMS "login" step shown in place of protected steps; removed from the step flow. */
	public get loginPromptStep(): StepBlock | undefined {
		return this._loginPromptStep;
	}

	public get pageType(): string {
		return this._pageModel?.contentType;
	}

	public get footerContent(): FooterReference {
		return this._pageModel?.frontendConfiguration?.footerReference;
	}

	public get headerContent(): HeaderReference {
		return this._pageModel?.frontendConfiguration.headerReference;
	}

	public get notificationBannerContent(): NotificationReference {
		return this._pageModel?.frontendConfiguration?.notificationReference;
	}

	// public get ChatbotContent(): boolean {
	// 	return this._pageModel?.hideAlbottaScript;
	// }

	public get content(): MainArea {
		return this._pageModel?.mainArea;
	}

	public get prePriceArea(): ContentArea {
		return this._pageModel?.prePriceArea;
	}

	public get priceArea(): ContentArea {
		return this._pageModel?.priceArea;
	}

	public get priceAreaFields(): FieldsContent[] {
		return this._pageModel?.priceArea?.items?.[0]?.content?.steps?.items?.[0]?.content?.fields?.items;
	}

	public get metaArea(): MetaArea {
		return this._pageModel?.metaArea;
	}

	public get theme(): Theme {
		return this._pageModel?.theme;
	}

	// public get url(): CanonicalUrl {
	// 	return this._pageModel?.canonicalUrl;
	// }
}

export const PageContext = React.createContext<Partial<Page>>(new Page(null));
